import { render, staticRenderFns } from "./MailAddressConfirm.vue?vue&type=template&id=2466dbdd&"
import script from "./MailAddressConfirm.vue?vue&type=script&lang=js&"
export * from "./MailAddressConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports